import MyChart from './MyChart';
import CsChart from './TopChart';
import { setColors, getChartList, appendChart } from './constant.js';

export const ChartList = {
  config: function ({ colors, charts = [] }) {
    // 设置颜色列表
    setColors(colors);

    // 注册新图表
    charts.forEach(appendChart);
  },
  get: getChartList,
};

export default CsChart;
export { MyChart };
